/*
 * @Autor:
 * @Date: 2024-01-11 22:07:36
 * @LastEditTime: 2024-01-11 22:45:21
 * @Description:
 * @FilePath: \register\src\components\Verifition\api\index.js
 */
import { ajax_method } from '@/utils/utils.js'
//获取验证图片
export function reqGet(data) {
  return new Promise((resolve, reject) => {
    ajax_method({
      url: '/captcha/get',
      data,
      type: 'POST',
      dataType: 'json',
      timeout: 60000,
      contentType: "application/json",
      success: (res) => { resolve(JSON.parse(res)) },
      error: reject
    })
  })
}

//滑动或者点选验证
export function reqCheck(data) {
  return new Promise((resolve, reject) => {
    ajax_method({
      url: '/captcha/check',
      data,
      type: 'POST',
      dataType: 'json',
      timeout: 60000,
      contentType: "application/json",
      success: (res) => { resolve(JSON.parse(res)) },
      error: reject
    })
  })
}



// WEBPACK FOOTER //
// ./src/components/Verifition/api/index.js